module.exports = __webpack_public_path__ + "static/media/SV.7aecb115.svg";